import type { VirtualDeviceConfiguration } from "@irriga-mais/common";
import type { AUTProject } from "@/api/queries/account";
import { getSectorVirtualDeviceConfig } from "./device";

export type ProjectWarningCode = "NO_SECTORS" | "SECTORS_NO_VALVES";

export type ProjectWarning = {
  message: string;
  severity: "info" | "warning" | "error";
  code: ProjectWarningCode;
};

export function calculateProjectWarnings(
  project: AUTProject,
  virtualDeviceConfigurations: VirtualDeviceConfiguration[]
) {
  const warnings: ProjectWarning[] = [];

  if (!project.sectors || project.sectors.length === 0) {
    warnings.push({
      message: "Nenhum setor configurado.",
      severity: "warning",
      code: "NO_SECTORS",
    });
  }
  if (
    project.sectors &&
    project.sectors.length > 0 &&
    project.sectors.some((sector) => !getSectorVirtualDeviceConfig(sector.id, virtualDeviceConfigurations))
  ) {
    warnings.push({
      message: "Existem setores sem válvula configurada.",
      severity: "warning",
      code: "SECTORS_NO_VALVES",
    });
  }

  return warnings;
}
